/**
 * Centralised route path constants for the app.
 *
 * Used by route tables (FE-4), guards, and navigation config. Adding paths
 * here is preferred over hard-coding strings in components.
 */

export const ROUTE_PATHS = {
  root: "/",

  // Public
  login: "/login",
  signup: "/signup",
  logout: "/logout",
  resetPassword: "/reset-password",
  newPassword: "/new-password",

  // Authenticated shell (desktop)
  home: "/home",
  homeBrowse: "/home/browse",
  homeWatchlist: "/home/watchlist",
  homeLibrary: "/home/library",
  homeUpload: "/home/upload",
  homeMovieReview: "/home/movie-review",
  homePairHeadset: "/home/pair_headset",
  homeOrderHistory: "/home/order_history",
  homeProfile: "/home/profile",
  homeAnalytics: "/home/analytics",

  // Top-level authenticated sections
  browse: "/browse",
  watchlist: "/watchlist",

  // Mobile
  mobile: "/mobile",
  mobileLogin: "/mobile/login",
  mobileSignup: "/mobile/signup",
  mobileHome: "/mobile/home",
  mobilePairHeadset: "/mobile/pair_headset",
  mobileProfile: "/mobile/profile",
  mobileOrderHistory: "/mobile/order_history",
} as const;

export type RoutePathKey = keyof typeof ROUTE_PATHS;
export type RoutePath = (typeof ROUTE_PATHS)[RoutePathKey];
